import { Component, Input, OnInit, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { OverlayService } from '../../../services/overlay.service';
import { AuthService } from '../../../services/auth.service';
import { FontsService, Font } from '../../../services/fonts.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-survey',
	templateUrl: './survey.component.html',
	styleUrls: ['./survey.component.scss']
})
export class SurveyComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@Input() noSpecialCharacters: any;
	@ViewChild('surveyForm', { static: true }) surveyForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	surveyFormSubscription: Subscription;
	frameError = new Array();
	colError = new Array();
	showList = true;
	cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	rows = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	maximumOptions = 12;
	maximumOptionsAdmin = 15;
	templateLocation = `${environment.dmAssetsDomain}/creator/survey/templates/`;
	templates = [
		{ name: 'Custom', fileName: 'custom' },
		{ name: 'NPS Circles Black', fileName: 'nps_circles_dark.json' },
		{ name: 'NPS Circles White', fileName: 'nps_circles_white.json' },
		{ name: 'NPS Pills Black', fileName: 'nps_pill_shaped.json' },
		{ name: 'NPS Squares Black', fileName: 'nps_squares_dark.json' },
		{ name: 'NPS Squares White', fileName: 'nps_squares_white.json' },
		{ name: 'Smiles', fileName: 'smiles_font-awesome.json' },
		{ name: 'Thumbs Up / Thumbs Down', fileName: 'thumbs_font-awesome.json' }
	];
	templateState = 'custom';
	isAdmin;
	fonts: Array<Font>;
	font;
	resultsTooltip;
	minimumImageSizeForResults = 100;

	constructor(
		private comService: ComponentService,
		private http: HttpClient,
		private overlay: OverlayService,
		private cd: ChangeDetectorRef,
		private auth: AuthService,
		private fontsService: FontsService,
		private router: Router
	) {}

	ngOnInit() {
		const currentDefaultTemplate = this.comService.getComponentTemplate(this.componentData.config.id, 0);
		this.componentData.config.version = this.router.url.includes('/duplicate/')
			? currentDefaultTemplate.config.version
			: this.componentData.config.version;

		this.isAdmin = this.auth.isAdmin();

		this.fonts = this.fontsService.getFonts();

		if (this.componentData.config.results && this.componentData.config.results.font) {
			this.font =
				this.fontsService.getFontsArray().indexOf(this.componentData.config.results.font) === -1
					? 'Custom Font'
					: this.componentData.config.results.font;
		}

		if (!this.componentData.config.template) {
			this.componentData.config.template = 'custom';
		}

		this.initialLayout();

		this.surveyFormSubscription = this.surveyForm.valueChanges
			.pipe(
				tap(() => {
					this.comService.updateDisabledSave(
						(this.surveyForm.dirty && this.surveyForm.invalid) || this.nameField.editComponentName
					);
					if (this.surveyForm.invalid) {
						for (var i = 0; i < this.componentData.config.rows * this.componentData.config.cols; i++) {
							this.colError[i] = 0;
							if (typeof this.surveyForm.controls['link' + i] !== 'undefined') {
								this.colError[i] = this.surveyForm.controls['link' + i].invalid ? 1 : 0;
							}
							if (typeof this.surveyForm.controls['response' + i] !== 'undefined') {
								this.colError[i] += this.surveyForm.controls['response' + i].invalid ? 1 : 0;
							} else {
								this.colError[i] += 1;
							}
						}
						for (var j = 0; j < this.componentData.config.rows; j++) {
							this.frameError[j] = 0;
							for (var k = 0; k < this.componentData.config.cols; k++) {
								this.frameError[j] += this.colError[j * this.componentData.config.cols + k];
							}
						}
					} else {
						this.frameError = [];
					}
				}),
				filter((form) => this.surveyForm.dirty && this.surveyForm.valid),
				debounceTime(2000)
			)
			.subscribe();
		if (
			!this.componentData.config.visual_editor_snippet &&
			(this.componentData.config.visual_editor_split || this.componentData.config.visual_editor_stack)
		) {
			this.componentData.config.visual_editor_snippet = true;
		}
	}

	ngOnDestroy() {
		this.surveyFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	createRange(number) {
		const items: number[] = [];
		for (let i = 1; i <= number; i++) {
			items.push(i);
		}
		return items;
	}

	shortenColumnCount(colCount) {
		let colChange = -(this.cols.length - colCount);
		this.cols.splice(colChange);
	}

	getColumnCount() {
		return Math.floor(this.maximumOptions / this.componentData.config.rows);
	}

	initialLayout() {
		let colCount = this.getColumnCount();
		if (colCount < this.cols.length) {
			this.shortenColumnCount(colCount);
		}
	}

	changeLayout(type) {
		if (type == 'rows') {
			let colCount = this.getColumnCount();
			if (colCount < this.cols.length) {
				this.shortenColumnCount(colCount);
				if (this.componentData.config.cols > this.cols[this.cols.length - 1]) {
					this.componentData.config.cols = this.cols[this.cols.length - 1];
				}
			} else {
				for (var i = this.cols[this.cols.length - 1]; this.cols.length < colCount; i++) {
					this.cols.push(i + 1);
				}
			}
		}

		while (this.componentData.config.items.length < this.componentData.config.rows * this.componentData.config.cols) {
			this.componentData.config.items.push({
				response: '',
				image: ''
			});
		}

		if (this.componentData.config.items.length > this.componentData.config.rows * this.componentData.config.cols) {
			let itemChange = -(this.componentData.config.items.length - this.componentData.config.rows * this.componentData.config.cols);
			this.componentData.config.items.splice(itemChange);
		}
	}

	visualEditorChange(type) {
		if (type == 'split' && this.componentData.config.visual_editor_split) {
			this.componentData.config.visual_editor_stack = false;
		} else if (type == 'stack' && this.componentData.config.visual_editor_stack) {
			this.componentData.config.visual_editor_split = false;
		}
	}

	changeTemplate(previous, event) {
		if (event != 'custom') {
			const templateChoice = this.templates.find((item) => item.fileName == event);
			if (
				confirm(
					`Are sure you want to update this component to use the ${templateChoice.name} template? All of your existing settings will be changed!`
				)
			) {
				const url = `${this.templateLocation}${event}`;
				this.http.get(url, { responseType: 'json' }).subscribe(
					(data) => {
						for (let key in data) {
							this.componentData.config[key] = data[key];
						}
						if (
							!this.componentData.config.visual_editor_snippet &&
							(this.componentData.config.visual_editor_split || this.componentData.config.visual_editor_stack)
						) {
							this.componentData.config.visual_editor_snippet = true;
						}
						this.componentData.config.template = event;
						this.cd.markForCheck();
						this.brodcastToPreview();
					},
					(error) =>
						this.overlay.updateOverlay(
							true,
							`Unable to retrieve ${templateChoice.name} template. Please contact dmsupport@optimove.com if you need help.`,
							'alert'
						)
				);
			} else {
				this.surveyForm.controls['template'].patchValue(previous);
			}
		} else {
			if (
				confirm(
					`The component will not be adjusted and you can modify the settings. All of your existing settings will remain until you adjust them.`
				)
			) {
				this.componentData.config.template = event;
			} else {
				this.surveyForm.controls['template'].patchValue(previous);
			}
		}
	}

	includeResultsCheck(event) {
		if (event) {
			if (!this.componentData.config.results) {
				this.font = this.fontsService.getFontsArray()[2];
				this.componentData.config['results'] = {
					min_clicks: '',
					font: this.font,
					'font-size': '15',
					color: '#000000',
					'background-color': '#ffffff',
					placement: 'top',
					alignment: 'left'
				};
			}
		}
	}

	allowResults() {
		let imageWidth;
		if (this.componentData.config.spacing > 0) {
			imageWidth = Math.floor(
				(this.componentData.config.item_width -
					(parseInt(this.componentData.config.cols, 10) + 1) * this.componentData.config.spacing) /
					parseInt(this.componentData.config.cols, 10)
			);
		} else {
			imageWidth = Math.floor(this.componentData.config.item_width / parseInt(this.componentData.config.cols, 10));
		}
		this.resultsTooltip = imageWidth < this.minimumImageSizeForResults;
		if (this.componentData.config.display_results && this.resultsTooltip) {
			this.componentData.config.display_results = false;
		}
	}

	checkVisualEditorRules() {
		this.componentData.config.visual_editor_snippet = false;
		this.visualEditorSnippet(false);
	}

	visualEditorSnippet(event) {
		if (!event) {
			this.componentData.config.visual_editor_stack = false;
			this.componentData.config.visual_editor_split = false;
		}
	}
}
